import { PrescriptionFormControllerApi } from "../../../../services";
import {
  getConfigObject,
  useMutationWithLoading,
} from "../../../../utils/utils";

interface Params {
  prescriptionFormId: string;
  status: boolean;
  xTENANTID?: string;
}

/**
 * @author Rajkumar Rathod
 */
export const useArchivePrescription = () =>
  useMutationWithLoading(async (params: Params) =>
    new PrescriptionFormControllerApi(
      getConfigObject()
    ).updatePrescriptionFormArchiveStatus(
      params?.prescriptionFormId,
      params?.status,
      params?.xTENANTID
    )
  );
